/**
 * 用户管理 web api
 * @author Xu
 * @create 2024-12-02 11:26:46
 */
import request from "@/utils/request"
import service from "@/utils/service"

/**
 * 设备类型
 */
export function type() {
  return [
    {id: 1, label: "MiraBot S2+"},
    {id: 2, label: "MiraBot S6"},
    {id: 99, label: "外部设备"},
  ]
}

/**
 * 用户类型
 */
export function userTypeList() {
  return [
    {id: 3, label: "设备账户"},
    {id: 2, label: "付费账户"},
    {id: 1, label: "测试账户"},
  ]
}

/**
 * 查询用户管理列表
 * @param param 查询参数
 */
export function list(param) {
  return request({
    url: service.tcode + "/tcode/user/list",
    method: "post",
    data: param
  })
}

/**
 * 保存用户管理数据
 * @param data 保存数据
 */
export function save(data) {
  return request({
    url: service.tcode + "/tcode/user/save",
    method: "post",
    data: data
  })
}

/**
 * 根据PK查询一个用户管理
 * @param pk 主键
 */
export function get(pk) {
  return request({
    url: service.tcode + "/tcode/user/get/" + pk,
    method: "get"
  })
}

/**
 * 批量删除
 * @param pks 主键数组
 */
export function deleteBatch(pks) {
  return request({
    url: service.tcode + "/tcode/user/deleteBatch",
    method: "post",
    data: pks
  })
}

/**
 * 根据PK删除 用户管理
 * @param pk 主键
 */
export function delData(pk) {
  return request({
    url: service.tcode + "/tcode/user/delete/" + pk,
    method: "get"
  })
}

/**
 * 根据用户PK查找绑定设备
 * @param pk 主键
 */
export function findDeviceListByUser(pk) {
  return request({
    url: service.tcode + "/tcode/device/findListByUser/" + pk,
    method: "get"
  })
}

/**
 * 启用 资源管理
 * @param pk 主键
 */
export function unseal(pk) {
  return request({
    url: service.tcode + "/tcode/user/unseal/" + pk,
    method: "get"
  })
}

/**
 * 封存 资源管理
 * @param pk 主键
 */
export function seal(pk) {
  return request({
    url: service.tcode + "/tcode/user/seal/" + pk,
    method: "get"
  })
}

/**
 * 查询自由模式-用户设置列表
 * @param pk 查询参数
 */
export function findProfileListByUserPk(pk, deviceType) {
  return request({
    url: service.tcode + "/tcode/profileuser/findListByUserPk/" + pk + "/" + deviceType,
    method: "get"
  })
}

/**
 * 查询自由模式-用户设置列表
 * @param pk 查询参数
 */
export function getUserProfile(pk) {
  return request({
    url: service.tcode + "/tcode/profileuser/get/" + pk,
    method: "get"
  })
}

/**
 * 查询自由模式-用户设置列表
 * @param pk 查询参数
 */
export function syncSysPresetProfileToUser(pk) {
  return request({
    url: service.tcode + "/tcode/profileuser/syncSysPresetProfileToUser/" + pk,
    method: "get"
  })
}

/**
 * 激活账号
 * @param map 主键数组
 */
export function accountActivation(map) {
  return request({
    url: service.tcode + "/tcode/api/pub/accountActivation",
    method: "post",
    data: map
  })
}

/**
 * 根据PK查询一个用户管理
 * @param pk 主键
 */
export function unbindDevice(pk_user_device) {
  return request({
    url: service.tcode + "/tcode/user/unbindDevice/" + pk_user_device,
    method: "get"
  })
}

/**
 * 激活用户
 * @param pk 用户pk
 */
export function activatedUser(pk) {
  return request({
    url: service.tcode + "/tcode/user/activateUserAccount/" + pk,
    method: "get"
  })
}

/**
 * 变更为付费账户
 * @param pk 用户pk
 */
export function changeToPayUserAccount(pk) {
  return request({
    url: service.tcode + "/tcode/user/setUserType/" + pk,
    method: "get"
  })
}



// WEBPACK FOOTER //
// ./src/api/tcode/user.js